import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Ethereal extends Modifier {
  static readonly baseTitle = 'Ethereal';
  static readonly baseText =
    'When attacked, if damage is less than or equal to stacks, negate the damage and fade. Temporary.';
  static readonly baseIcon = 'ethereal';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Late;

  // Instance properties that can change
  title = Ethereal.baseTitle;
  text = Ethereal.baseText;
  icon = Ethereal.baseIcon;
  tags: Array<ModifierTags> = [...Ethereal.baseTags];
  priority = Ethereal.basePriority;

  damageIn(damage: Damage) {
    if (damage.value > 0 && damage.value <= this.stacks) {
      damage.value = 0;
      this.removeStacks(1);
    }
  }

  startTurn() {
    this.removeStacks(this.stacks);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Ethereal, Ethereal);
